const ApiNavs ={
    'body':'',
    'navTopHeight': 0,
    'navContentHeight': 0,
    'start': function(){
        let self = this;
        self.init();
        self.initNavs();

    },
    'initNavs': function(){
        let self = this;

        let navTop = self.body.find('div.nav-top');
        let navContent = self.body.find('div.nav-content');
        self.navTopHeight = navTop.height();
        self.navContentHeight = navContent.height();
        navContent.css('top','-'+self.navContentHeight+'px');

        // console.log(self.navTopHeight);
        // console.log(self.navContentHeight);

        self.setNavs();
    },
    'setNavs': function(){
        let self = this;
        let navContent = self.body.find('div.nav-content');
        let navTriggers = self.body.find('[nav-trigger]');
        navTriggers.unbind('click');
        navTriggers.each(function(){
            let navTrigger = $(this);
            navTrigger.on('click',function(){
                let thisClick = $(this);

                navContent.animate(
                    { top: self.navTopHeight+'px'},
                    300,
                    'swing'
                );

                let navClose = navTrigger.closest('div.icon-group').find('[nav-close]');
                navTrigger.addClass('hidden');
                navClose.removeClass('hidden');

                self.setClickOutside(navContent);
                self.setNavTopClose(navTrigger);
            });
        });
    },
    'setNavTopClose': function(navTrigger){
        let self = this;

        let navContent = self.body.find('div.nav-content');
        let navCloses = navTrigger.closest('div.icon-group').find('[nav-close]');
        navCloses.unbind('click');
        navCloses.each(function(){
            let navClose = $(this);
            navClose.on('click', function(){
                let thisClick = $(this);
                // console.log('nav close');

                navContent.animate(
                    { top: '-'+(self.navTopHeight+self.navContentHeight)+'px'},
                    300,
                    'swing'
                );


                navClose.addClass('hidden');
                navTrigger.removeClass('hidden');

                self.setNavs();
            });
        })

    },
    'setClickOutside': function(navContent){
        let self = this;

        $(document).unbind('click');
        $(document).on('click', function(e){
            let target = $(e.target);
            let isNavIcon = target.closest('div.icon-group');
            let navTrigger = self.body.find('[nav-trigger="nav-top"]');
            let isNavContent = target.closest('div.nav-content');

            // console.log(isNavIcon);
            // console.log(isNavContent);

            if (isNavContent.length <= 0 && isNavIcon.length <= 0){
                navContent.animate(
                    { top: '-'+(self.navTopHeight+self.navContentHeight)+'px'},
                    300,
                    'swing'
                );

                navTrigger.closest('div.icon-group').find('[nav-close]').addClass('hidden');
                navTrigger.closest('div.icon-group').find('[nav-trigger]').removeClass('hidden');

                self.setNavs();
            }
        });

    },
    'init':function(){
        let self = this;
        self.body = $('body');
    }
}

$(document).ready(function(){
    ApiNavs.start();
});
